
import { defineComponent } from 'vue';
import { useMeta } from 'vue-meta';

export default defineComponent({
  setup() {
    useMeta({
      title: 'Clothes'
    });
  },
  data() {
    return {
      imagesLoaded: 0,
      clothes: [] as string[],
      tees: [
        'tee-2',
        'tee-3',
        'tee-4',
        'tee-5',
        'tee-6',
        'tee-7',
        'tee-8',
        'tee-9',
        'tee-10'
      ],
      cropTops: [
        'crop-top-2',
        'crop-top-3',
        'crop-top-4',
        'crop-top-5',
        'crop-top-6',
        'crop-top-7',
        'crop-top-8',
        'crop-top-9',
        'crop-top-10'
      ],
      longSleeves: [
        'long-sleeve-2',
        'long-sleeve-3',
        'long-sleeve-4',
        'long-sleeve-5',
        'long-sleeve-6',
        'long-sleeve-7',
        'long-sleeve-8',
        'long-sleeve-9',
        'long-sleeve-10'
      ],
      sleeveless: [
        'sleeveless-2',
        'sleeveless-3',
        'sleeveless-4',
        'sleeveless-5',
        'sleeveless-6',
        'sleeveless-7',
        'sleeveless-8',
        'sleeveless-9',
        'sleeveless-10'
      ],
      puffySleeves: [
        'puffy-sleeve-2',
        'puffy-sleeve-3',
        'puffy-sleeve-4',
        'puffy-sleeve-5',
        'puffy-sleeve-6',
        'puffy-sleeve-7',
        'puffy-sleeve-8',
        'puffy-sleeve-9',
        'puffy-sleeve-10'
      ],
      cupcakeDresses: [
        'cupcake-dress-2',
        'cupcake-dress-3',
        'cupcake-dress-4',
        'cupcake-dress-5',
        'cupcake-dress-6',
        'cupcake-dress-7'
      ],
      sweaters: [
        'a-color',
        'bomber-jacket',
        'pullover',
        'after-school-jacket',
        'dreamy',
        'retro-carpet',
        'argyle',
        'hoodie-tee',
        'blooming-day',
        'private-school'
      ]
    };
  },
  mounted() {
    this.clothes = [
      ...this.tees,
      ...this.cropTops,
      ...this.longSleeves,
      ...this.sleeveless,
      ...this.puffySleeves,
      ...this.cupcakeDresses,
      ...this.sweaters
    ];
  },
  unmounted() {
    this.clothes = [];
  },
  computed: {
    currentClothes(): string {
      return `${this.$route.query.clothes}`;
    }
  },
  methods: {
    changeCurrentClothes(clothes: string): void {
      if (clothes) {
        this.$router.replace({
          query: { ...this.$route.query, clothes }
        });
      }
    }
  }
});
